import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ControlContainer, UntypedFormGroup } from '@angular/forms';
import { ObservationSectionPermissionsDTO } from 'src/app/model/observation/observation-section-permissions-dto.model';
import { ResourceData } from 'src/app/services/resource/resource.service';

@Component({
    selector: 'app-ntpe-section-one-goals',
    templateUrl: './section-one-goals.component.html',
    styleUrls: ['./section-one-goals.component.scss']
})
export class SectionOneGoalsComponent implements OnInit {
    @Input() readOnly: boolean = true;
    @Input() resourceFile?: ResourceData = {};
    @Input() permissions?: ObservationSectionPermissionsDTO;
    @Input() formGroup!: UntypedFormGroup;
    @Input() actionPlanSaved!: boolean;
    @Output() actionPlanChanged = new EventEmitter();
    @Output() continue = new EventEmitter<any>();
    @Output() feedback = new EventEmitter();
    @Output() save = new EventEmitter<any>();

    constructor(private controlContainer: ControlContainer) { }

    ngOnInit(): void { }

    onActionPlanChanged = () => this.actionPlanChanged.emit();
    onContinueClick = () => this.continue.emit();
    onFeedbackClick = () => this.feedback.emit();
    onSaveClick = (event: any) => this.save.emit(event);

}
